module.exports = __webpack_public_path__ + "img/qingse.69b04aad.png";